/**
 * Created by matheusmorett on 11/06/18.
 */
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react'
import { Route, Switch } from 'react-router-dom';
import AsyncComp from 'components/hocs/AsyncComponent'
import SafeRoute from 'components/SafeRoute'

//auth
const Login = AsyncComp(() => import('modules/auth/containers/Login').then(module => module.default))
const ForgotPassword = AsyncComp(() => import('modules/auth/containers/ForgotPassword').then(module => module.default))
const NewPassword = AsyncComp(() => import('modules/auth/containers/NewPassword').then(module => module.default))
const Dashboard = AsyncComp(() => import('modules/dashboard/containers/Dashboard').then(module => module.default))

//adventure
const Adventures = AsyncComp(() => import('modules/adventure/containers/Adventures').then(module => module.default))
const AdventurePublished = AsyncComp(() => import('modules/adventure/containers/modules/adventureData/containers/AdventurePublished').then(module => module.default))
const EditAdventure = AsyncComp(() => import('modules/adventure/containers/EditAdventure').then(module => module.default))
const AdventureRouter = AsyncComp(() => import('modules/adventure/AdventureRouter').then(module => module.default))

//profile
const ProfileRouter = AsyncComp(() => import('modules/profile/ProfileRouter').then(module => module.default))

//reservation
const CreateReservation = AsyncComp(() => import('modules/reservations/containers/CreateReservation').then(module => module.default))
const VoucherList = AsyncComp(() => import('modules/reservations/containers/VoucherList').then(module => module.default))
const VoucherAdventureSelection = AsyncComp(() => import('modules/reservations/containers/VoucherAdventureSelection').then(module => module.default))
const RequestOverview = AsyncComp(() => import('modules/reservations/containers/RequestOverview').then(module => module.default))
const RequestDetail = AsyncComp(() => import('modules/reservations/containers/RequestDetail').then(module => module.default))
const AlterReservation = AsyncComp(() => import('modules/reservations/containers/AlterReservation').then(module => module.default))
const AddTag = AsyncComp(() => import('modules/reservations/containers/AddTag').then(module => module.default))

//schedule
const Schedule = AsyncComp(() => import('modules/schedule/containers/Schedule').then(module => module.default))
const EditCalendar = AsyncComp(() => import('modules/adventure/containers/EditCalendar').then(module => module.default))

//finances
const FinancesTransfer = AsyncComp(() => import('modules/finances/containers/FinancesTransfer').then(module => module.default))

const FinancesOverview = AsyncComp(() => import('modules/finances/containers/FinancesOverview').then(module => module.default))

//Site
const SiteProvider   = AsyncComp(() => import('modules/site/containers/SiteProvider').then(module => module.default))
const AboutUs        = AsyncComp(() => import('modules/site/containers/AboutUs').then(module => module.default))
const MetricOne      = AsyncComp(() => import('modules/site/containers/MetricOne').then(module => module.default))
const MetricTwo      = AsyncComp(() => import('modules/site/containers/MetricTwo').then(module => module.default))
const MetricThree    = AsyncComp(() => import('modules/site/containers/MetricThree').then(module => module.default))
const Color          = AsyncComp(() => import('modules/site/containers/Color').then(module => module.default))
const SocialNetwork  = AsyncComp(() => import('modules/site/containers/SocialNetwork').then(module => module.default))
const Logo           = AsyncComp(() => import('modules/site/containers/Logo').then(module => module.default))
const AddressAndContact = AsyncComp(() => import('modules/site/containers/AddressAndContact').then(module => module.default))

// Onboarding
const OnboardingRouter = AsyncComp(() => import('modules/onboarding/OnboardingRouter').then(module => module.default))

@inject('AuthStore')
@observer
class Router extends Component {

  constructor(props) {
    super(props);

    this.callbackPushNotification = this.callbackPushNotification.bind(this)
  }

  componentDidMount() {
    document.addEventListener('callbackPushNotification', this.callbackPushNotification);
  }

  componentWillUnmount() {
    document.removeEventListener('callbackPushNotification', this.callbackPushNotification);
  }

  callbackPushNotification() {
    const { history } = this.props;
    history.push('/reservations/');
  }

  render() {
    const { AuthStore } = this.props;
    return (
      <Switch>
        <Route path="/login" component={Login} />
        <Route path="/forgot-password" component={ForgotPassword} />
        <Route path="/reset-password" component={NewPassword} />

        <SafeRoute user={AuthStore.user} exact path="/adventures" component={Adventures} />
        <SafeRoute user={AuthStore.user} exact path="/adventure-published" component={AdventurePublished} />
        <SafeRoute user={AuthStore.user} path='/adventures/create' component={AdventureRouter} />
        <SafeRoute user={AuthStore.user} exact path='/adventures/edit/:id' component={EditAdventure} />
        <SafeRoute user={AuthStore.user} path='/adventures/edit/:id' component={AdventureRouter} />

        <SafeRoute user={AuthStore.user} exact path="/reservations" component={RequestOverview} />
        <SafeRoute user={AuthStore.user} exact path="/reservations/vouchers/adventures" component={VoucherAdventureSelection} />
        <SafeRoute user={AuthStore.user} exact path="/reservations/vouchers/list" component={VoucherList} />
        <SafeRoute user={AuthStore.user} exact path="/reservations/create-reservation" component={CreateReservation} />
        <SafeRoute user={AuthStore.user} exact path="/reservations/reservation-detail/:id" component={RequestDetail} />
        <SafeRoute user={AuthStore.user} exact path="/reservations/reservation-detail/alter-reservation/:id" component={AlterReservation} />
        <SafeRoute user={AuthStore.user} exact path="/reservations/reservation-detail/tags/:id" component={AddTag} />
        <SafeRoute user={AuthStore.user} exact path="/reservations/reservation-detail/reserve-tags/:id/:reserve" component={AddTag} />
        
        <SafeRoute user={AuthStore.user} path="/dashboard" component={Dashboard} />

        <SafeRoute user={AuthStore.user} exact path="/schedule" component={Schedule} />
        <SafeRoute user={AuthStore.user} exact path="/config-schedule" component={EditCalendar} />

        <SafeRoute user={AuthStore.user} exact path="/finances" component={FinancesOverview} />
        <SafeRoute user={AuthStore.user} exact path="/finances/transfer" component={FinancesTransfer} />

        <SafeRoute user={AuthStore.user} exact path="/profile/site" component={SiteProvider} />
        <SafeRoute user={AuthStore.user} exact path="/profile/site/about-us" component={AboutUs} />
        <SafeRoute user={AuthStore.user} exact path="/profile/site/about-us/metric-1" component={MetricOne} />
        <SafeRoute user={AuthStore.user} exact path="/profile/site/about-us/metric-2" component={MetricTwo} />
        <SafeRoute user={AuthStore.user} exact path="/profile/site/about-us/metric-3" component={MetricThree} />
        <SafeRoute user={AuthStore.user} exact path="/profile/site/social-network" component={SocialNetwork} />
        <SafeRoute user={AuthStore.user} exact path="/profile/site/color" component={Color} />
        <SafeRoute user={AuthStore.user} exact path="/profile/site/logo" component={Logo} />
        <SafeRoute user={AuthStore.user} exact path="/profile/site/address-and-contact" component={AddressAndContact} />
        <SafeRoute user={AuthStore.user} path="/profile" component={ProfileRouter} />
        
        <Route path="/onboarding" component={OnboardingRouter} />
        
        <Route path="/" component={Login} />
      </Switch>
    );
  }
}

export default Router;


// WEBPACK FOOTER //
// ./src/router/router.js